export default "__VITE_ASSET__220318c8__"